import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=4019f9b8&"
import script from "./message-bubble.vue?vue&type=script&lang=js&"
export * from "./message-bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports